module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Current Signature")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [(_vm.isLoading) ? _c('div', [_c('label', [_vm._v("Loading...")])]) : _vm._e(), _vm._v(" "), (!_vm.currentSignature && !_vm.isLoading) ? _c('div', [_c('label', [_vm._v("No signature uploaded")])]) : _vm._e(), _vm._v(" "), (_vm.currentSignature) ? _c('div', [_c('img', {
    attrs: {
      "src": _vm.currentSignature
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.currentSignature) ? _c('div', [_c('button', {
    staticClass: "btn btn-secondary col-md-1",
    on: {
      "click": _vm.deleteSignature
    }
  }, [_vm._v("Delete")])]) : _vm._e()]), _vm._v(" "), _c('hr', {
    staticStyle: {
      "border": "solid 1px #cccccc"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Upload New Signature")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('form', {
    staticClass: "form",
    attrs: {
      "id": "documentForm",
      "data-vv-scope": "mediaFile"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('mediaFile.newFile')
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    ref: "newFile",
    staticClass: "file",
    attrs: {
      "name": "newFile",
      "type": "file"
    }
  }), _vm._v(" "), _c('div', [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('mediaFile.newFile')),
      expression: "errors.has('mediaFile.newFile')"
    }],
    staticClass: "has-error"
  }, [_vm._v("File is required")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.serverErrorList.length > 0),
      expression: "serverErrorList.length > 0"
    }]
  }, [_c('span', {
    staticClass: "has-error"
  }, [_vm._v("Validation issues must be corrected prior to submit")]), _vm._v(" "), _c('ul', {
    staticClass: "has-error"
  }, _vm._l((_vm.serverErrorList), function(serverError) {
    return _c('li', {
      key: serverError
    }, [_vm._v(_vm._s(serverError))])
  }))])])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary col-md-1",
    on: {
      "click": _vm.saveSignature
    }
  }, [_vm._v("Upload")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-254634d4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserSignature.vue
// module id = 910
// module chunks = 1